<div class="content1">
  <div class="step-row">
    <div class="step"></div>
    <div class="step on"></div>
  </div>


  <div>
    <h1 class="page-title">Welcome back!</h1>
    <p class="page-sub">Don't have an account? <a [routerLink]="authService.REGISTER_ROUTE">Register</a></p>
  </div>

  <form class="glass" [formGroup]="userForm" (ngSubmit)="LoginUser()">
    <div class="card-body">
      <!--          Email-->
      <div class="form-flex-row">
        <mat-form-field class="form-field" appearance="fill">
          <mat-label>Email</mat-label>
          <input id="email" type="email" autocomplete="off" matInput formControlName="email"/>
        </mat-form-field>
      </div>
      <!--          Password-->
      <div class="form-flex-row">
        <mat-form-field class="form-field"  appearance="fill">
          <mat-label>Password</mat-label>
          <input matInput autocomplete="off" formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
          <mat-icon matSuffix class="pointer" 
            [title]="showPassword ? 'Hide Password' : 'Show Password'"
            (click)="showPassword = !showPassword">
            {{showPassword ? 'visibility_off' : 'visibility'}}
          </mat-icon>
          <mat-hint align="end" color="primary" [routerLink]="authService.RESET_PASSWORD_ROUTE">Forgot password?</mat-hint>
          <mat-error>Password must contain lowercase, uppercase, numbers, special characters, and be at
            least 8 characters
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="text-center">
          <button mat-raised-button type="submit" color="primary">Login</button>
        </div>
      </div>
    </div>
  </form>

  <div class="mat-divider"></div>
  <div class="page-foot">
    <span class="regulatory-main-foorter">Rondeivu operates through its affiliates: Rondeivu Securities, LLC (US broker-dealer), Rondeivu Advisory, LLC (Connecticut state investment adviser), and Rondeivu (Canada) Inc. (Canadian EMD/PM). See our full regulatory disclosures on our homepage.</span>
  </div>


</div>


